<template>
    <div class="categories-wrapper product-form-tab">
        <transition name="vue-table-loader">
            <div class="vue-details-loader" v-if="showLoading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
        </transition>
        <div class="row">
            <div class="col-md-8">
                <p class="text-muted mb-2 max-w-para text-xs">
                    Products can be grouped into categories for easy organization. Similar to products, categories
                    can be assigned a number of data points including assets, descriptive text and SEO data. Categories
                    can also have child & parent categories. Within the Jasper PIM app all categories are derived from a
                    required 'Root' category.
                </p>
                <h3 class="pt-3" v-if="!showLoading">Assigned Categories</h3>
            </div>
            <div class="col-md-4">
                <select class="form-control" v-model="filteredCategory">
                    <option value="">Filter By Root Category</option>
                    <option v-for="root in allRootCategories" :key="root.id">{{root.name}}</option>
                </select>
            </div>
        </div>

        <div class="assigned-category-list pb-4" v-show="!showLoading">
            <div class="assigned-list">
                <category-item v-for="(item, idx) in assignedCategoriesPaginated" :key="idx"
                    :item-details="item"
                    :all-items="assignedCategories"
                    :all-assignments="assignedCategories"
                    :depth="0"
                    :is-flat="true"
                    @add="handleAssignNewCat" @remove="handleRemoveCat">
                </category-item>
                <list-paginator :mappingsPerPage="10" :targetList="filteredAssignedCategories" @results="handlePaginationResults"></list-paginator>
            </div>
        </div>
        <h3 class="pt-3" v-if="!showLoading && $parent.permissionAllowed('manage_products')">All Categories</h3>
        <div class="available-category-list pb-4" v-show="!showLoading" v-if="$parent.permissionAllowed('manage_products')">
            <div class="results position-relative">
                <category-item v-for="(item, idx) in filteredRootCategories" :key="idx"
                    :item-details="item"
                    :all-items="allCategories"
                    :all-assignments="assignedCategories"
                    :depth="0"
                    :is-flat="false"
                    @add="handleAssignNewCat" @remove="handleRemoveCat">
                </category-item>
                <div class="vue-details-loader p-0" v-if="showCategoryLoading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
            </div>
        </div>
      </div>

</template>

<script>

import Vue from "vue";

let base_url = window.location.protocol + "//" + window.location.host

import axios from 'axios'

import ListPaginator from '../generic/list-pagination.vue';
import CategoryListItem from './product-details-category-item.vue';
import BaseFilterBar from '../tables/base-filter-bar.vue';

export default {
    name: "product-categories",
    components: {
        'base-filter-bar': BaseFilterBar,
        'list-paginator': ListPaginator,
        'category-item': CategoryListItem,
    },
    props: {
        productDetails: Object,
    },
    data() {
        return {
            showCategoryLoading: false,
            showLoading: true,
            categorySearchValue: "",
            allCategoriesRaw: [],
            rootCategories: [],
            allCategories: [],
            allCategoriesFiltered: [],
            assignedCategoriesPaginated: [],
            assignedCategories: [],
            filteredCategory: "",
        };
    },
    mounted() {
        this.showLoading = true;
        this.$emit("get-categories");
        this.loadAllRootCategories();
        // this.loadAllCategories();
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))
        this.$events.$on('filter-reset', e => this.onFilterReset())
    },
    computed: {
        allRootCategories() {
            return this.rootCategories;
        },
        filteredRootCategories() {
            if (this.filteredCategory !== "") {
                return this.rootCategories.filter(el => {
                    return (el.fqn_cache.indexOf(this.filteredCategory)!== -1);
                })
            }
            return this.rootCategories;
        },
        filteredAssignedCategories() {
            if (this.filteredCategory !== "") {
                return this.assignedCategories.filter(el => {
                    return (el.fqn_cache.indexOf(this.filteredCategory)!== -1);
                })

            }
            return this.assignedCategories;
        }
    },
    methods: {

        refreshAssignedCategoriesForProduct() {
          axios.get(base_url+ '/pimapi/products/' + this.productDetails.info.id + '/categories')
              .then((response) => {
                this.assignedCategories = response.data;
              })
              .catch((error) => {
                this.showLoading = false;
              });
        },

        loadAllRootCategories() {
            axios.get(base_url + '/pimapi/categories/root')
                .then((response) => {
                    this.rootCategories = response.data;
                })
                .catch((error) => {
                    this.showLoading = false;
                });
        },
        loadAllCategories() {
          axios.get(base_url+ '/pimapi/categories')
              .then((response) => {
                this.allCategories = response.data;
              })
              .catch((error) => {
                this.showLoading = false;
              });
        },

        handleAssignNewCat(id) {
            this.showLoading = true;
            axios.post(base_url+ '/pimapi/products/' + this.productDetails.info.id + '/categories/'+id)
            .then((response) => {
                this.refreshAssignedCategoriesForProduct();
                this.showLoading = false;
            })
            .catch((error) => {
                this.showLoading = false;
            });
        },
        removeAllCats() {
            this.assignedCategories = [];
        },
        handleRemoveCat(id) {
            for (let i = 0; i < this.assignedCategories.length; i++) {
                if (this.assignedCategories[i].id == id) {
                    this.showLoading = true;
                    axios.delete(base_url+ '/pimapi/products/' + this.productDetails.info.id + '/categories/'+id)
                        .then((response) => {
                            this.assignedCategories.splice(i, 1);
                            this.showLoading = false;
                        })
                        .catch((error) => {
                            this.showLoading = false;
                        });
                    break;
                }
            }
        },
        handlePaginationResults(newList) {
            this.assignedCategoriesPaginated = newList;
        },
        handleFilterResults(newFilteredList) {
            this.allCategoriesFiltered = newFilteredList;
        },
        updatedCategories(all, assigned) {
            this.assignedCategories = assigned;
            this.showLoading = false;
        },
        orderCategoriesByTree(all) {
            let sorted = [];
            all.forEach(element => {
                if (element.parent_id == null) {
                    sorted.push(element);
                    //search for children of this element
                    this.buildChildBranch(sorted, element);
                }
            });
            return sorted;
        },
        buildChildBranch(arr, el) {
            let kids = this.getChildrenForId(this.allCategoriesRaw, el.id);
            kids.forEach(element => {
                arr.push(element);
                //RECURSION!Assigned Categories
                this.buildChildBranch(arr, element);
            });
            return kids;
        },
        getChildrenForId(targetArray, id) {
            return targetArray.filter((el) => {
                return (el.parent_id == id);
            });

        },
        constructAssignedCategoryArray(assigned) {
            return this.allCategoriesFiltered.filter((el) => {
                for (let i=0; i< assigned.length; i++) {
                    if (assigned[i].id == el.id) {
                        return true;
                    }
                }
                return false;
            });
        }
    },
};
</script>

<style>

.list-filter-wrapper {
    padding-bottom: 10px;
}
.small-action {
    font-size: 10px;
}

</style>
